import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-salary-forms',
    templateUrl: './salary-forms.component.html',
    styleUrl: './salary-forms.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SalaryFormsComponent {
  constructor(
  ) {
  }
}
